/**

Coded by www.techhighway.ca

*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useState } from "react";

// Preserve Table Search, Sort and Entries per page Context
export const PreserveTable = createContext({
  status: {},
  parameter: {},
  user: {},
  permission: {},
  wildlifeAuction: {},
  setPreserveStatus: () => {},
  setPreserveParameter: () => {},
  setPreserveUser: () => {},
  setPreservePermission: () => {},
  setPreserveWildlifeAuction: () => {},
  reset: () => {},
});

function PreserveTableProvider({ children }) {
  const [status, setStatus] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "name",
    sort_column_value: "asc",
    search_value: "",
  });
  const [parameter, setParameter] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [user, setUser] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "first_name",
    sort_column_value: "asc",
    search_value: "",
  });
  const [permission, setPermission] = useState({
    page_no: 1,
    page_size: 10,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
  });
  const [wildlifeAuctionActive, setWildlifeAuctionActive] = useState({
    page_no: 1,
    page_size: 100,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
    show_filter: false,
    filter_data: {}
  });
  const [wildlifeAuctionClosed, setWildlifeAuctionClosed] = useState({
    page_no: 1,
    page_size: 100,
    sort_column: "id",
    sort_column_value: "desc",
    search_value: "",
    show_filter: false,
    filter_data: {}
  });

  const setPreserveStatus = async (status) => {
    setStatus(status);
  };
  const setPreserveParameter = async (parameter) => {
    setParameter(parameter);
  };
  const setPreserveUser = async (user) => {
    setUser(user);
  };
  const setPreservePermission = async (permission) => {
    setPermission(permission);
  };
  const setPreserveWildlifeAuctionActive = async (auction) => {
    setWildlifeAuctionActive(auction);
  };
  const setPreserveWildlifeAuctionClosed = async (auction) => {
    setWildlifeAuctionClosed(auction);
  };

  const reset = () => {
    setPreserveStatus({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "asc",
      search_value: "",
    });
    setPreserveParameter({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveUser({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "asc",
      search_value: "",
    });
    setPreservePermission({
      page_no: 1,
      page_size: 10,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
    });
    setPreserveWildlifeAuctionActive({
      page_no: 1,
      page_size: 100,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
      show_filter: false,
      filter_data: {}
    });
    setPreserveWildlifeAuctionClosed({
      page_no: 1,
      page_size: 100,
      sort_column: "id",
      sort_column_value: "desc",
      search_value: "",
      show_filter: false,
      filter_data: {}
    });
  };

  return (
    <PreserveTable.Provider
      value={{
        status,
        parameter,
        user,
        permission,
        wildlifeAuctionActive,
        wildlifeAuctionClosed,
        setPreserveStatus,
        setPreserveParameter,
        setPreserveUser,
        setPreservePermission,
        setPreserveWildlifeAuctionActive,
        setPreserveWildlifeAuctionClosed,
        reset,
      }}
    >
      {children}
    </PreserveTable.Provider>
  );
}

export { PreserveTableProvider };
